import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  TemplateRef,
} from '@angular/core';

import { DialogOptions } from './types';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogComponent implements OnChanges {
  @Input() options?: DialogOptions<any>;
  @Input() contentTemplateRef?: TemplateRef<any>;
  @Input() data?: any;
  @Input() width = '95vw';
  @Output() accept = new EventEmitter<void>();
  @Output() reject = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  visible = false;
  closable = true;
  maximizable = true;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['options']) {
      this.visible = this.options?.visible ?? false;
      this.closable = this.options?.closable ?? true;
      this.maximizable = this.options?.maximizable ?? true;
    }
  }

  onAccept() {
    this.accept.emit();
  }

  onReject() {
    this.reject.emit();
  }

  onClose() {
    this.close.emit();
  }

  onChangeVisible(value: boolean) {
    if (!value) {
      this.onClose();
    }
  }
}
